import { StatePanel } from '@3dspinit/ui';

export function EarnPage() {
  return (
    <main className="page page--narrow">
      <h1 style={{ fontFamily: 'var(--font-display)' }}>Earn</h1>
      <StatePanel
        variant="default"
        title="Creator and host opportunities"
        message="Sales, eligible affiliate referrals, and host participation require approved terms and seller onboarding (R3). Payouts remain disabled until policy and provider readiness are verified."
      />
    </main>
  );
}
